import { createTheme } from '@mui/material';

export const defaultTheme = createTheme({
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        // outlined: {
        //   '&:hover': {
        //     backgroundColor: '#35C37D',
        //   },
        // },
        outlined: ({ theme }) => ({
          '&:hover': {
            backgroundColor: 'transparent',
            color: theme.palette.primary.dark,
          },
        }),
      },
    },
  },
  palette: {
    mode: 'light',
    common: {
      white: '#FFFFFF',
      black: '#000000',
    },
    primary: {
      light: '#FDE9CC',
      main: '#F59100',
      dark: '#C47400',
      contrastText: '#fff',
    },
    brands: {
      cadhoc: {
        main: '#C50E1F',
      },
      cultureCheck: {
        main: '#C5007B',
      },
      readCheck: {
        main: '#0070B8',
      },
      personalServices: {
        main: '#009EE3',
      },
      lunch: {
        main: '#F59100',
      },
    },
    grey: {
      '200': '#F2F2F2',
      '400': '#D7D7D7',
      '600': '#979797',
      '800': '#494949',
    },
    info: {
      main: '#039EB2',
    },
    error: {
      main: '#D0021B',
    },
    warning: {
      main: '#C07300',
    },
    success: {
      main: '#6DBD8E',
    },
    text: {
      primary: '#4E5B59',
      secondary: '#4A4A4A',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    fontFamily: ['Roboto', 'sans-serif'].join(','),
    h1: {
      fontSize: '2.625rem',
      letterSpacing: '0',
      lineHeight: '3.4375',
    },
    h2: {
      fontSize: '2.25rem',
      letterSpacing: '0',
      lineHeight: '3',
    },
    h3: {
      fontSize: '1.5rem',
      letterSpacing: '0',
      lineHeight: '2',
    },
    h4: {
      fontSize: '1.25rem',
      letterSpacing: '0',
      lineHeight: '1.625',
    },
    body1: {
      fontSize: '1rem',
      letterSpacing: '0',
      lineHeight: '1.3125',
    },
    body2: {
      fontSize: '0.875rem',
      letterSpacing: '0',
      lineHeight: '1.1875',
    },
    button: {
      fontSize: '0.875rem',
      fontWeight: 700,
      letterSpacing: '0',
      lineHeight: '1.1875',
      textTransform: 'uppercase',
    },
    subtitle1: {
      fontSize: '0.75rem',
      letterSpacing: '0',
      lineHeight: '1rem',
    },
    caption: {
      fontSize: '0.625rem',
      letterSpacing: '0',
      lineHeight: '0.8125',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});
